import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container } from 'reactstrap';
import BulkImportLogView from './BulkImportLogView'

const BulkImportLog = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Admin Settings" title="Bulk Import Log" mainTitle="Bulk Import Log" />
            <Container fluid={true}>
                <BulkImportLogView />
            </Container>
        </Fragment>
    )
}

export default BulkImportLog
